module.exports = __webpack_public_path__ + "img/II-26.057d6b25.svg";